const API_BASE = '';

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    },
    ...options
  });

  const contentType = response.headers.get('Content-Type') || '';
  const hasJson = contentType.includes('application/json');
  const body = hasJson ? await response.json() : null;

  if (!response.ok) {
    const error = new Error(body?.error || `Request failed with status ${response.status}`);
    error.status = response.status;
    throw error;
  }

  return body;
}

export const api = {
  identify(email) {
    return request('/api/auth/identify', {
      method: 'POST',
      body: JSON.stringify({ email })
    });
  },

  getMe() {
    return request('/api/auth/me');
  },

  logout() {
    return request('/api/auth/logout', { method: 'POST' });
  },

  getData() {
    return request('/api/data');
  },

  getTargets() {
    return request('/api/targets');
  },

  createTarget(target) {
    return request('/api/targets', {
      method: 'POST',
      body: JSON.stringify(target)
    });
  },

  updateTarget(id, target) {
    return request(`/api/targets/${id}`, {
      method: 'PUT',
      body: JSON.stringify(target)
    });
  },

  deleteTarget(id) {
    return request(`/api/targets/${id}`, { method: 'DELETE' });
  },

  upsertEntry(date, targetId, value) {
    return request('/api/entries', {
      method: 'PUT',
      body: JSON.stringify({ date, targetId, value })
    });
  },

  createReward(reward) {
    return request('/api/rewards', {
      method: 'POST',
      body: JSON.stringify(reward)
    });
  },

  deleteReward(id) {
    return request(`/api/rewards/${id}`, { method: 'DELETE' });
  },

  createPunishment(punishment) {
    return request('/api/punishments', {
      method: 'POST',
      body: JSON.stringify(punishment)
    });
  },

  deletePunishment(id) {
    return request(`/api/punishments/${id}`, { method: 'DELETE' });
  },

  clearTrackingData() {
    return request('/api/tracking/clear', { method: 'POST' });
  }
};
